{
  "login": {
    "title": "Login",
    "welcome": "Welcome to Muru",
    "please sign in": "It's great to see you again",
    "login": "Login",
    "errors": {
      "general": "Could not sign you in. Please check your email and password are correct.",
      "email": "Please enter a valid email",
      "password": "Please enter a valid password"
    }
  },
  "signup": {
    "welcome": "Signup for Muru",
    "title": "Signup",
    "signup_btn": "Next",
    "errors": {
      "general": "Could not sign you up. Please try again"
    }
  },
  "forgot_password": {
    "welcome": "Reset your password",
    "title": "Reset your password",
    "submit_btn": "Reset your password"
  },
  "orgs": {
    "select": {
      "title": "Select an organization",
      "heading": "Select an organization",
      "body": "To continue, please select an organization that you are a member of."
    },
    "none available": {
      "heading": "No agencies available",
      "contact": "You currently don't belong to any agencies within Muru. Click below to find your agency and get started."
    }
  },
  "org_invite": {
    "title": "You've been invited to an organization"
  },
  "admin": {
    "users": {
      "manage": "Manage Users"
    },
    "organizations": {
      "manage": "Manage Organizations"
    },
    "hospitals": {
      "create": "Create new hospital",
      "list": "Manage hospitals",
      "update": "Update hospital"
    }
  },
  "common": {
    "title": "%s | Muru | The protocol app EMS deserves",
    "email": "Email address",
    "name": "Name",
    "password": "Password",
    "passwordConfirmation": "Confirm password",
    "errors": {
      "not_authorized": "You're not allowed to view that page"
    }
  }
}
